<script>
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed } from '@state/helpers'
// import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'
import formatDate from '@utils/format-date'
import PermissionTable from '@router/views/admin/PermissionTable.vue'

const initData = () => {
  return {
    block: 0,
    canBlock: 1,
    email: '',
    firstName: '',
    groupIds: [],
    id: '',
    lastName: '',
  }
}

export default {
  page: {
    title: '排班人員',
    meta: [{ name: 'description', content: 'Staff List' }],
  },

  components: {
    ListItem: () => lazyLoadComponent(import('./components/ListItem')),
    BaseButtonDialog,
    PermissionTable,
    ScheduleStaffFormAdd: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffFormAdd')),
    ScheduleStaffDetail: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffDetail')),
  },
  props: {
    userRecords: {
      type: Number,
      default: 10,
    },
    merchantProducts: {
      type: Array,
      default: () => [],
    },
    // 是否是空間模式搜尋
    isSpace: {
      type: Boolean,
      default: false,
    },
    // 看要打API的是哪種types
    fetchTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      staffs: [],
      dialogVisible: false,
      dialogItem: {},
      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽

      visibleDetail: false,
      staffDetail: {},
      tryingFetchDetail: false,
      visibleEdit: false,
      selectUserVisible: false,
      permissionDialogVisible: false,
      tryingGetUser: false,
      selectUser: initData(),
      addUserToStaffData: {},
      userList: [],
      accountId: 0,
      filterData: {},
      categoryList: [],
      nameOrPhone: '', // 姓名or電話搜尋
      superManager: false,
      inComponentIsSpace: false,
      pageAddBtnRecords: 0, // 打api回來的records(計算人員)
      pageAccountListRecords: 0, // 帳號列表的records
    }
  },
  computed: {
    addItemTitle() {
      return this.isSpace ? '新增空間' : '新增人員'
    },
    ...merchantComputed,
    checkRecords() {
      // 如果是空間就不擋點下去
      if (this.isSpace) {
        return false
      }
      if (this.currentMerchant?.plan) {
        // this.pageAddBtnRecords => 目前已有人數
        // this.pageAccountListRecords => 帳號列表人數
        // this.currentMerchant.plan.accounts => 這個plan可以被設定的人數
        const staffRecords = this.pageAddBtnRecords + this.pageAccountListRecords
        return this.currentMerchant.plan.accounts <= staffRecords
      }
      return true
    },
    dialogTitle() {
      const modeTitleMap = {
        add: '創建人員',
        edit: '編輯人員',
        view: '項目人員',
      }
      return modeTitleMap[this.dialogMode]
    },
    filterStaffs() {
      if (this.staffs.length === 0) return []
      let filterResult = JSON.parse(JSON.stringify(this.staffs))
      if (this.nameOrPhone.length > 0) {
        filterResult = filterResult.filter((item) => item.name.includes(this.nameOrPhone) || item.phoneCode.includes(this.nameOrPhone) || item.phoneNumber.includes(this.nameOrPhone))
      }
      if (this.filterData.productId && this.filterData.productId.length > 0) {
        const { name } = this.merchantProducts.find((data) => data.id === this.filterData.productId)
        filterResult = filterResult.filter((item) => item.storeTitles.find((title) => title.includes(name)))
      }
      if (this.filterData.blockStatus === '0' || this.filterData.blockStatus === '1') {
        filterResult = filterResult.filter((item) => item.block === +this.filterData.blockStatus)
      }
      return filterResult
    },
  },
  watch: {
    selectUserVisible(value) {
      if (!value) {
        this.selectUser = initData()
      }
    },
  },
  async mounted() {
    this.inComponentIsSpace = this.isSpace
    await this.tryToFetchList()
    this.reset()
    this.$set(this.filterData, 'blockStatus', '0')
  },
  methods: {
    async tryToFetchList() {
      try {
        const { items, records } = await this.$store.dispatch('schedule/fetchStaffForAllResponse', {
          paginate: 0,
          type: this.fetchTypes[0],
        })
        const { records: records2 } = await this.$store.dispatch('merchant/fetchAllResponseUsersForStaff', { onlyConnectableUser: 1 })
        this.staffs = items // 人員列表
        this.pageAddBtnRecords = records // 目前有多少人
        this.pageAccountListRecords = records2 // 帳號列表有多少人
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * @description 點擊美容師名單 -> 開啟畫面
     * @param {*} id
     */
    async tryToFetchDetail(id) {
      this.tryingFetchDetail = true
      try {
        this.staffDetail = await this.$store.dispatch('schedule/fetchStaffDetail', {
          id,
          page: 1,
          limit: 10,
          date: formatDate(new Date(), 'YYYY-MM'),
        })
        this.visibleDetail = true
        this.showOffOutetTab('none')
      } finally {
        this.tryingFetchDetail = false
      }
    },
    updateList() {
      this.tryToFetchList()
      this.closeEdit()
    },
    openDialog(mode, itemData) {
      this.dialogVisible = true
      this.dialogMode = mode
      this.$set(this.$data, 'dialogItem', itemData)
    },
    async openEdit(mode, itemData) {
      this.accountId = 0
      let title = ''

      if (this.isSpace) {
        title = this.addItemTitle
      } else {
        title = mode === 'add' ? '創建人員' : '編輯人員'
      }
      
      this.$store.commit('title/SET_TITLE', title)
      this.dialogMode = mode
      if (mode === 'add') {
        this.$set(this.$data, 'dialogItem', itemData)
        this.visibleEdit = true
        this.showOffOutetTab('none')
      } else {
        await this.tryToFetchDetail(itemData.id)
        this.visibleEdit = true
        this.visibleDetail = false
        this.$set(this.$data, 'dialogItem', this.staffDetail)
      }
    },
    showOffOutetTab(type) {
      this.$emit('showOffOuterTab', {
        displayType: type,
        pageType: 'tabList',
      })
    },
    closeEdit() {
      this.visibleEdit = false
      this.dialogItem = {}
      this.$store.commit('title/SET_TITLE', '')
      this.showOffOutetTab('block')
    },
    openSelectUser() {
      this.tryToSearchUser()
      this.selectUserVisible = true
    },
    openRoleTable() {
      this.selectRoleVisible = true
    },
    async tryToSearchUser() {
      this.tryingGetUser = true
      const { items } = await this.$store.dispatch('merchant/fetchAllResponseUsersForStaff', { onlyConnectableUser: 1 })
      this.userList = items
      this.tryingGetUser = false
    },
    async sendLinkUser() {
      if (this.selectUser.groupIds.includes(7)) {
        this.superManager = true
      }
      this.$store.commit('title/SET_TITLE', this.addItemTitle)
      this.dialogMode = 'add'
      this.staffDetail = {
        name: this.selectUser.firstName,
        email: this.selectUser.email,
        userGroupIds: this.selectUser.groupIds,
        superManager: this.superManager,
      }
      this.accountId = this.selectUser.id
      // await this.tryToFetchDetail(this.addUserToStaffData.id)
      // this.staffDetail.phoneCode= '+886' // 強制國碼886
      this.selectUserVisible = false
      this.visibleEdit = true
      this.visibleDetail = false
      this.showOffOutetTab('none')
      this.$set(this.$data, 'dialogItem', this.staffDetail)
    },
    backTolist() {
      this.visibleDetail = false
      this.tryToFetchList()
      this.showOffOutetTab('block')
    },
    addBackTolist() {
      this.visibleEdit = false
      this.tryToFetchList()
      this.showOffOutetTab('block')
    },
    handleExport() {},
    reset() {
      try {
        this.nameOrPhone = ''
        this.$set(this.filterData, 'productId', '')
        this.$set(this.filterData, 'blockStatus', '')
      } catch (error) {
        console.error(error.message)
      }
    },
  },
}
</script>

<template>
  <div v-loading.fullscreen.lock="tryingFetchDetail" element-loading-text="取得人員資訊中">
    <div v-if="!visibleDetail && !visibleEdit">
      <!-- 上方button -->
      <div :class="$style.headerStyle">
        <span v-if="!isSpace">
          <el-button class="is-round" @click="permissionDialogVisible = true">
            <BaseIcon name="user-plus" />
            <span>管理權限表</span>
          </el-button>
        </span>
        <span>
          <el-button class="is-round" @click="openSelectUser">
            <BaseIcon name="user-plus" />
            <span>帳號列表</span>
          </el-button>
        </span>
        <span>
          <el-button :disabled="checkRecords" class="is-round" type="primary" @click="openEdit('add')">
            <BaseIcon name="plus" />
            <span>{{ addItemTitle }}</span>
          </el-button>
        </span>
      </div>
      <div>
        <BaseTableSearch
          v-slot="{ fields }"
          class="isForTab2"
          :default-value.sync="filterData"
          hide-action
          @reset="reset"
          @handleExport="handleExport"
          @tryToFetchList="tryToFetchList"
          :growStatus="true"
          reset-btn-style="width:84px;height:44px;"
        >
          <el-form-item prop="status" class="w-full">
            <el-input v-model="nameOrPhone" :placeholder="'請輸入姓名或電話搜尋'" class="is-border smsInput" style="width:387px;">
              <BaseIcon slot="prefix" name="search" class="el-input__icon" />
            </el-input>
          </el-form-item>
          <el-form-item prop="status" class="w-full">
            <el-select v-model="fields.productId" placeholder="分店">
              <el-option label="所有分店" value></el-option>
              <el-option v-for="(product, index) in merchantProducts" :key="index" :label="product.name" :value="product.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="w-full">
            <el-select v-model="fields.blockStatus" placeholder="狀態">
              <el-option label="狀態選擇" value></el-option>
              <el-option label="啟用中" value="0"></el-option>
              <el-option label="停權中" value="1"></el-option>
            </el-select>
          </el-form-item>
        </BaseTableSearch>
        <div :class="$style['item__outerPadding']">
          <div :class="[$style['item__list'], $style[`item__list--last-${filterStaffs.length % 4}`]]">
            <ListItem
              v-for="item in filterStaffs"
              :key="item.id"
              :data="item"
              :class="$style.item"
              @view="(itemData) => tryToFetchDetail(itemData.id)"
              @edit="(itemData) => openEdit('edit', itemData)"
            />
          </div>
        </div>
        <el-dialog title="帳號列表" :visible.sync="selectUserVisible" top="0" width="800px" height="586px" append-to-body>
          <template v-if="userList.length > 0">
            <!-- <p style="margin-top: 0; margin-bottom: 25px">請從下方選取您欲新增的排班人員</p> -->
            <div class="el-radio-wrapper">
              <div class="el-radio-wrapper__title"> <span>管理人員</span> <span>帳號狀態</span> </div>
              <el-radio-group v-model="selectUser" v-loading="tryingGetUser" class="vertical-radio">
                <el-radio v-for="item in userList" :key="item.id" border :label="item">
                  {{ item.firstName }}
                  <span class="select__option--meta" :class="$style.morePaddingR">
                    <span :style="`color: ${item.block ? '#e35d5d' : '#60a32f'}`">
                      <!-- {{ item.block ? '停權中' : '啟用中' }} -->
                      <BaseIcon v-if="!item.block" name="check-circle" class="only-icon" />
                      <BaseIcon v-else name="times-circle" />
                    </span>
                  </span>
                </el-radio>
              </el-radio-group>
            </div>

            <!-- <el-table :data="userList" style="width: 710px;">
              <el-table-column prop="firstName" label="角色名稱" width="490" align="left">
              </el-table-column>
              <el-table-column prop="block" label="列入排班" width="220" align="center">
                <template slot-scope="scope">
                  <BaseIcon v-if="scope.row.block.toString() === '0'" name="check-circle" class="only-icon" />
                  <BaseIcon v-else name="times-circle" />
                </template>
              </el-table-column>
            </el-table> -->
          </template>
          <el-alert v-else title="目前沒有可以新增的帳號" type="warning" :closable="false"></el-alert>

          <div class="bottom-btn-center">
            <el-button class="is-round" @click="selectUserVisible = false">取消</el-button>
            <el-button class="is-round" type="primary" :disabled="!selectUser.id" @click="sendLinkUser">確認</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 編輯人員 -->
    <div style="margin-top:-15px;padding-left:0">
      <ScheduleStaffDetail v-if="visibleDetail && !visibleEdit" :fetch-types="fetchTypes" :is-space="isSpace" :default-value.sync="staffDetail" @back="backTolist"> </ScheduleStaffDetail>
    </div>

    <!-- 新增人員、新增空間 -->
    <div style="margin-top:-15px">
      <ScheduleStaffFormAdd
        v-if="visibleEdit"
        :fetch-types="fetchTypes"
        :is-space="isSpace"
        :default-value="dialogItem"
        :account-id="accountId"
        @store="updateList"
        @close="closeEdit"
        @goBack="addBackTolist"
      />
    </div>

    <BaseButtonDialog
      v-can:api="'addAdmin'"
      only-dialog
      title="身份與權限表"
      :dialog-visible.sync="permissionDialogVisible"
      :dialog-props="{ width: '80%' }"
      button-type="info"
      button-icon-name="info"
      order="2"
      width="1135px"
      floating
    >
      <PermissionTable show-owner />
    </BaseButtonDialog>
  </div>
</template>
<style lang="scss" module>

$column-number: 4;

.headerStyle {
  display: flex;
  justify-content: end;
  padding: 5px 0 0;
  background-color: $color-body-bg;
  padding-bottom: 18px;

  > span:not(:last-child) {
    margin-right: 10px;
  }
}

.bodyPadding {
  padding: 18px 23px;
}

.morePaddingR {
  padding-right: 18px;
}

.item {
  width: calc(100% / #{$column-number} - 15px);
  padding: 58px 10px 12px;
  margin-bottom: 30px;
  background-color: white;
  cursor: pointer;
  transition: $all-transition;

  @include max-sm {
    width: calc(100% - 0.5rem);
  }

  &:hover {
    @include layer-elevation(8);
  }

  &__outerPadding {
    padding: 20px 20px 0;
    background-color: white;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &--last-1:after {
      width: calc(100% / #{$column-number} * 3 - 15px);
      content: '';
    }

    &--last-2:after {
      width: calc(100% / #{$column-number} * 2 - 15px);
      content: '';
    }

    &--last-3:after {
      width: calc(100% / #{$column-number} * 1 - 15px);
      content: '';
    }

    &--last-4:after {
      width: calc(100% / #{$column-number} * 0 - 15px);
      content: '';
    }
  }
}

.displayOpen {
  display: block;
}

:global {
  .el-table_1_column_1 {
    div.cell {
      padding-left: 45px;
    }
  }
}
</style>
